import { Helmet } from "react-helmet-async";
import "./Pricing.css";
export function PricingPage() {
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.5/font/bootstrap-icons.min.css"
  />;

  return (
    <>
      <Helmet>
        <title>Yuva Quest | Connect with Indian Culture and Heritage</title>
        <meta
          name="description"
          content="Choose the right plan to connect kids with Indian culture. Flexible, affordable pricing for parents, schools, and partners."
        />
      </Helmet>
      <div className="my_custom_section">
        <p className="webUi">Subscribe Now</p>
      </div>
      <div className="container">
        <div className="plandiv">
          <label className="webUi">One Plan. One Price.</label>
          <label className="webUi endlessDiv ">Endless Learning.</label>
        </div>
        <div className="horizontalLine">
          <hr />
        </div>
        <div className="container d-flex flex-wrap align-items-center justify-content-center py-5">
          {/* Left Section */}
          <div className=" text-md-start flex-grow-1">
            <h2 className="text-decoration-line-through  webUi mainPriceTextCut">
              $79.99
            </h2>
            <h1 className="webUi mainPriceText">$40.00</h1>
            <p className="webUi " style={{ fontSize: "14px" }}>
              yearly / kid
            </p>
            <ul className="list-unstyled text-black ">
              <li className="webUi">
                <i
                  className="bi bi-check-circle-fill "
                  style={{ color: "rgb(68, 76, 231)" }}
                ></i>{" "}
                Unlimited Access to All Quests, Series, & Games
              </li>
              <li className="webUi">
                <i
                  className="bi bi-check-circle-fill "
                  style={{ color: "rgb(68, 76, 231)" }}
                ></i>{" "}
                Full Progress Tracking for Every Kid
              </li>
              <li className="webUi">
                <i
                  className="bi bi-check-circle-fill "
                  style={{ color: "rgb(68, 76, 231)" }}
                ></i>{" "}
                Exclusive Early Access to New Quests & Content
              </li>
              <li className="webUi">
                <i
                  className="bi bi-check-circle-fill "
                  style={{ color: "rgb(68, 76, 231)" }}
                ></i>{" "}
                Immersive Experiences in Indian Culture & more
              </li>
              <li className="webUi">
                <i
                  className="bi bi-check-circle-fill "
                  style={{ color: "rgb(68, 76, 231)" }}
                ></i>{" "}
                Family-Friendly Content with No Ads or Interruptions
              </li>
            </ul>
            <div>
              <p className="childrenLimit webUi text-black">ADD MORE Kid</p>
              <div>
                <input type="checkbox" id="second-child" />
                <label
                  htmlFor="second-child"
                  className="childrenLimit webUi text-black"
                >
                  {" "}
                  2ND Kid [+$40.00]
                </label>
              </div>
              <div>
                <input type="checkbox" id="third-child" />
                <label
                  htmlFor="third-child"
                  className="childrenLimit webUi text-black"
                >
                  {" "}
                  3RD Kid [+$40.00]
                </label>
              </div>
            </div>
            <button className="btn btn-primary subscribebtn ">
              <label className="webUi">SUBSCRIBE</label>
            </button>
          </div>

          {/* Right Section */}
          <div className="flex-grow-1 d-flex justify-content-center">
            <img
              src="https://yuvaquest.com/wp-content/uploads/2024/08/Image.png"
              alt="Characters"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
